import { render } from "./TransactionInfo.vue?vue&type=template&id=34ab3a5c"
import script from "./TransactionInfo.vue?vue&type=script&lang=js"
export * from "./TransactionInfo.vue?vue&type=script&lang=js"

import "./TransactionInfo.vue?vue&type=style&index=0&id=34ab3a5c&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/testnet.onegate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__